<ng-container *ngIf="!isLoading">
  <div>
    <div style="margin-left: 70%; margin-bottom: 2%">
      <!-- <button
        [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}, span : {'font-size':'14px', 'font-weight':'600', 'float':'left'}}"
        class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
        printSectionId="print-section" ngxPrint>
        print
      </button> -->

      <button class="noPrint"
        style="margin-right: 2%; margin-left: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>

      <button class="noPrint" style="margin-top: 2% 2% 0 2%;" (click)="exportExcel('Talukawise_Indetail_Subscription_Bussiness_Report')"
        mat-raised-button color="primary">
        Export
      </button>
      <button mat-dialog-close class="btn noPrint">
        Close
      </button>
    </div>
  </div>
  <div>
    <div class="container" id="print-section1">
      <table class="table table-bordered">
        <thead>

 <tr>
            <th [attr.colspan]="totalth - 0" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              हिंदुस्थान प्रकाशन संस्था - विवेक साप्ताहिक - वर्गणी विभाग
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ today | date:'dd-MM-yyyy' }}
            </th>
          </tr>

            <tr>
            <th [attr.colspan]="totalth - 3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              वर्गणीदार नोंदणी - नवीन / नूतनीकरण रोजमेळ - तालुकानुसार
              <span *ngIf="appliedFilters">
                    <small>
                        <!-- <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'"> |<strong>देश:</strong>  <strong>{{ appliedFilters.country }}</strong></span>
                        <span *ngIf="appliedFilters.state"> | <strong>राज्य:</strong> {{ appliedFilters.state }}</span>
                        <span *ngIf="appliedFilters.district"> |<strong>जिल्हा:</strong> {{ appliedFilters.district }}</span>
                        <span *ngIf="appliedFilters.taluka"> | <strong>तालुका:</strong> {{ appliedFilters.taluka }}</span>
                        <span *ngIf="appliedFilters.subscriptionType"> |<strong>वर्गणी प्रकार:</strong>  {{ appliedFilters.subscriptionType }}</span>
                        <span *ngIf="appliedFilters.rep"> | <strong>प्रतिनिधी: </strong> {{ appliedFilters.rep }}</span>
                        <span *ngIf="appliedFilters.officerep"> |<strong>कार्यालय प्रतिनिधी:</strong> {{ appliedFilters.officerep }}</span>
                        <span *ngIf="appliedFilters.prant"> | <strong>प्रांत:</strong> {{ appliedFilters.prant }}</span>
                        <span *ngIf="appliedFilters.receiptType"> | <strong>पावती प्रकार:</strong> {{ appliedFilters.receiptType }}</span> -->


                        <span *ngIf="appliedFilters.country && appliedFilters.country.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>देश:</strong> <strong>{{ appliedFilters.country }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.state && appliedFilters.state.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>राज्य:</strong> <strong>{{ appliedFilters.state }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.district && appliedFilters.district.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>जिल्हा:</strong> <strong>{{ appliedFilters.district }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.taluka && appliedFilters.taluka.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>तालुका:</strong> <strong>{{ appliedFilters.taluka }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.subscriptionType && appliedFilters.subscriptionType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>वर्गणी प्रकार:</strong> <strong>{{ appliedFilters.subscriptionType }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.rep && appliedFilters.rep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रतिनिधी:</strong> <strong>{{ appliedFilters.rep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.officerep && appliedFilters.officerep.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>कार्यालय प्रतिनिधी:</strong> <strong>{{ appliedFilters.officerep }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.prant && appliedFilters.prant.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>प्रांत:</strong> <strong>{{ appliedFilters.prant }}</strong>
                        </span>

                        <span *ngIf="appliedFilters.receiptType && appliedFilters.receiptType.toLowerCase() !== 'all'" style="font-size:12px;">
                          | <strong>पावती प्रकार:</strong> <strong>{{ appliedFilters.receiptType }}</strong>
                        </span>


                    </small>
                </span>
            </th>

            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              दिनांक - {{ startDate | date:'dd-MM-yyyy' }}
            </th>
            <th colspan="3" class="largeHeading"
              style="text-align: center; font-size: 14px; border-left: 1px solid black; border-top: 1px solid black; border-bottom: 1px solid black; border-right: 1px solid black;">
              पर्यंत - {{ endDate | date:'dd-MM-yyyy' }}
            </th>
          </tr>

          <tr>
            <th rowspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 1px solid black; font-size: 13px;">देश</th> 
            <th rowspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 1px solid black; font-size: 13px;">राज्य</th> 
            <th rowspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 1px solid black; font-size: 13px;">जिल्हा</th> 
            <th rowspan="1" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 1px solid black; font-size: 13px;">तालुका</th>
            <th colspan="4" style="font-weight: bold; border-left: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; font-size: 13px;">एकूण</th>
            <ng-container *ngFor="let data of subTypesName"> 
              <ng-container *ngIf="data.isVisible">
                <th colspan="4" style="font-weight: bold; font-size: 13px; border-left: 2px solid black; border-top: 2px solid black; border-right: 2px solid black; border-bottom: 2px solid black;">{{ data.name }}</th>
              </ng-container>
            </ng-container>
          </tr>
           <tr>
            <th colspan="1" style="border-left: 2px solid black; border-bottom: 2px solid black;"></th>
            <th colspan="1" style="border-left: 2px solid black; border-bottom: 2px solid black;"></th>
            <th colspan="1" style="border-left: 2px solid black; border-bottom: 2px solid black;"></th>
            <th colspan="1" style="border-left: 2px solid black; border-bottom: 2px solid black;"></th>
            <th style="font-weight: bold; font-size: 13px; border-left: 2px solid black; border-bottom: 2px solid black; word-wrap: break-word;">वर्गणीदार संख्या</th>
            <th style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; word-wrap: break-word;">रक्कम</th>
            <th style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; word-wrap: break-word;">नवीन</th>
            <th style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
            <ng-container *ngFor="let data of subTypesName">
              <th *ngIf="data.isVisible" style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; word-wrap: break-word;">नवीन</th>
              <th *ngIf="data.isVisible"  style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; word-wrap: break-word;">नूतनीकरण</th>
              <th *ngIf="data.isVisible"  style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; word-wrap: break-word;">एकूण</th>
              <th *ngIf="data.isVisible"  style="font-weight: bold; font-size: 13px; border-bottom: 2px solid black; border-right: 2px solid black; word-wrap: break-word;">रक्कम</th>
            </ng-container>
          </tr> 
         
          
        </thead>
        <tbody>

        <ng-container *ngFor="let data of finalData; let i = index">
  <tr
    [ngStyle]="{
      'font-weight': data.isDistrictTotal || i === finalData.length - 1 ? 'bold' : 'normal',
      'border-top': i === finalData.length - 1 || data.isDistrictTotal ? '2px solid black' : '1px solid black',
      'border-bottom': i === finalData.length - 1 || data.isDistrictTotal ? '2px solid black' : '1px solid black'
    }"
  >
    <!-- Country -->
    <td style="word-wrap: break-word; border: 2px solid black;">
      <ng-container *ngIf="i === 0 || finalData[i - 1]['country'] !== data['country']">
        {{ data['country'] }}
      </ng-container>
    </td>

    <!-- State -->
    <td style="word-wrap: break-word; border: 2px solid black;">
      <ng-container *ngIf="i === 0 || finalData[i - 1]['state'] !== data['state']">
        {{ data['state'] }}
      </ng-container>
    </td>

    <!-- District -->
    <td style="word-wrap: break-word; border: 1px solid black; border-right: 2px solid black;">
      <ng-container *ngIf="data.isDistrictTotal">
        <strong>{{ data['district_name'] }} :- एकूण</strong>
      </ng-container>
      <ng-container *ngIf="!data.isDistrictTotal && i !== finalData.length - 1">
        <ng-container *ngIf="i === 0 || finalData[i - 1]['district_name'] !== data['district_name']">
          {{ data['district_name'] }}
        </ng-container>
      </ng-container>
      <ng-container *ngIf="i === finalData.length - 1 && !data.isDistrictTotal">
        <strong>एकूण :</strong>
      </ng-container>
    </td>

    <!-- Taluka -->
    <td style="word-wrap: break-word; border: 1px solid black; border-right: 2px solid black;">
      <ng-container *ngIf="!data.isDistrictTotal && (i === 0 || finalData[i - 1]['taluka'] !== data['taluka'])">
        {{ data['taluka'] }}
      </ng-container>
    </td>

    <!-- Total Columns -->
    <td style="border: 1px solid black; text-align: right;">
      {{ (data['नवीन'] || 0) + (data['नूतनीकरण'] || 0) }}
    </td>
    <td style="border: 1px solid black; text-align: right;">
      {{ data['एकूण'] }}
    </td>
    <td style="border: 1px solid black; text-align: right;">
      {{ data['नवीन'] }}
    </td>
    <td style="border: 1px solid black; text-align: right; border-right: 2px solid black;">
      {{ data['नूतनीकरण'] }}
    </td>

    <!-- Subscription Types -->
    <ng-container *ngFor="let sub of subTypesName">
      <ng-container *ngIf="sub.isVisible">
        <td style="border: 1px solid black; text-align: right;">
          {{ data[getKey(sub.name) + '_नवीन'] || 0 }}
        </td>
        <td style="border: 1px solid black; text-align: right;">
          {{ data[getKey(sub.name) + '_नूतनीकरण'] || 0 }}
        </td>
        <td style="border: 1px solid black; text-align: right;">
          {{ (data[getKey(sub.name) + '_नवीन'] || 0) + (data[getKey(sub.name) + '_नूतनीकरण'] || 0) }}
        </td>
        <td style="border: 1px solid black; text-align: right; border-right: 2px solid black;">
          {{ data[getKey(sub.name) + '_एकूण'] || 0 }}
        </td>
      </ng-container>
    </ng-container>
  </tr>
</ng-container>


        </tbody>
        
<div *ngIf="isLoading" class="main-loading">
  <span class="loader"></span>
  <p>Loading...</p>
</div>